import { Box, Button, Typography } from '@mui/material'
import KycSteps from './KycSteps'
import { BottomSheetContainer } from './MuiComponents'
import { t } from '~/utils/narration'
export default function Welcome({ onContinue }: any) {
  return (
    <>
      <img
        src="/images/your-logo.jpeg"
        style={{ alignSelf: 'center', width: 200, marginBottom: 24 }}
      />
      <Typography variant="h3" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
        {t({ en: 'Let’s get your KYC verified', hi: 'केवाईसी की प्रक्रिया शुरू करें' })}
      </Typography>
      {/* <Box flex={0.5} /> */}
      <Typography variant="subtitle1" color="#66667a" gutterBottom sx={{ textAlign: 'left' }}>
        {t({
          en: "Complete your KYC with Demo Bank. It'll be quick and easy! The steps include:",
          hi: 'डेमो बैंक के साथ अपना केवाईसी पूरा करें। यह तेज़ और आसान होगा! इसकी प्रक्रिया इस प्रकार है:',
        })}
      </Typography>
      {/* <Typography variant="subtitle1" color="#66667a" gutterBottom sx={{ textAlign: 'left'}}>
        The steps include:
      </Typography> */}
      <KycSteps />
      <BottomSheetContainer maxWidth="sm">
        <Box sx={{}}>
          <Typography
            variant="h6"
            fontWeight={600}
            py={1}
            borderBottom="2px solid rgba(0,0,0,0.06)"
          >
            {t({ en: 'Start your KYC', hi: 'अपना केवाईसी शुरू करें' })}
          </Typography>
        </Box>
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography
            variant="subtitle1"
            color="#66667a"
            gutterBottom
            sx={{ mb: 2, textAlign: 'start' }}
          >
            {t({
              en: "Follow the on-screen instructions—it'll only take 2 minutes of your time!",
              hi: 'स्क्रीन पर दिए गए निर्देशों का पालन करें—इसमें आपके केवल 2 मिनट लगेंगे!',
            })}
          </Typography>
          <Button fullWidth onClick={onContinue} size="large" sx={{ py: 1.5 }}>
            {t({ en: 'Start', hi: 'शुरू करें' })}
          </Button>
        </Box>
      </BottomSheetContainer>
    </>
  )
}
